var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216.274,
    y: 194.695,
    className: "st0",
    width: 88.279,
    height: 39.722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.274,
    y: 137.32,
    className: "st0",
    width: 88.279,
    height: 39.723
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.032,
    y: 194.695,
    className: "st0",
    width: 88.28,
    height: 39.722
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.032,
    y: 137.32,
    className: "st0",
    width: 88.28,
    height: 39.723
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.377,93.672H57.375v140.746h128.002V93.672z M141.321,170.275h-39.88v-43.848h39.88V170.275z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,250.604c0,101.515,79.445,167.724,79.445,167.724h300.144C467.861,378.605,512,250.604,512,250.604H0z  M388.19,319.372c-8.126,0-14.71-6.584-14.71-14.71c0-8.126,6.584-14.711,14.71-14.711c8.127,0,14.719,6.585,14.719,14.711 C402.909,312.788,396.317,319.372,388.19,319.372z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransport);
export default __webpack_public_path__ + "static/media/transport.07123626f66578aa6becb4998c637154.svg";
export { ForwardRef as ReactComponent };